"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/internal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalAccountServiceGetCoreFansByBrandIdResponse = exports.InternalAccountServiceGetCoreFansByBrandIdRequest = exports.InternalAccountServiceGetTenantOwnerByBrandIdResponse = exports.InternalAccountServiceGetTenantOwnerByBrandIdRequest = exports.InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse = exports.InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest = exports.InternalAccountServiceGetTenantByIdResponse = exports.InternalAccountServiceGetTenantByIdRequest = exports.InternalAccountServiceGetTenantByFirestoreIdResponse = exports.InternalAccountServiceGetTenantByFirestoreIdRequest = exports.InternalAccountServiceAddBrandToTenantResponse = exports.InternalAccountServiceAddBrandToTenantRequest = exports.InternalAccountServiceGetBrandByIdsResponse = exports.InternalAccountServiceGetBrandByIdsRequest = exports.InternalAccountServiceGetBrandsResponse = exports.InternalAccountServiceGetBrandsRequest = exports.InternalAccountServiceGetBrandByIdResponse = exports.InternalAccountServiceGetBrandByIdRequest = exports.InternalAccountServiceGetBrandByFirestoreIdResponse = exports.InternalAccountServiceGetBrandByFirestoreIdRequest = exports.InternalAccountServiceGetFanByFirestoreIdResponse = exports.InternalAccountServiceGetFanByFirestoreIdRequest = exports.InternalAccountServiceGetFanByIdResponse = exports.InternalAccountServiceGetFanByIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const internal_common_pb_1 = require("./internal_common_pb");
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetFanByIdRequest
 */
class InternalAccountServiceGetFanByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetFanByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetFanByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetFanByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetFanByIdRequest, a, b);
    }
}
exports.InternalAccountServiceGetFanByIdRequest = InternalAccountServiceGetFanByIdRequest;
InternalAccountServiceGetFanByIdRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetFanByIdRequest.typeName = "spwn.account.v1.InternalAccountServiceGetFanByIdRequest";
InternalAccountServiceGetFanByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetFanByIdResponse
 */
class InternalAccountServiceGetFanByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetFanByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetFanByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetFanByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetFanByIdResponse, a, b);
    }
}
exports.InternalAccountServiceGetFanByIdResponse = InternalAccountServiceGetFanByIdResponse;
InternalAccountServiceGetFanByIdResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetFanByIdResponse.typeName = "spwn.account.v1.InternalAccountServiceGetFanByIdResponse";
InternalAccountServiceGetFanByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fan", kind: "message", T: internal_common_pb_1.InternalFan },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetFanByFirestoreIdRequest
 */
class InternalAccountServiceGetFanByFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetFanByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetFanByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetFanByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetFanByFirestoreIdRequest, a, b);
    }
}
exports.InternalAccountServiceGetFanByFirestoreIdRequest = InternalAccountServiceGetFanByFirestoreIdRequest;
InternalAccountServiceGetFanByFirestoreIdRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetFanByFirestoreIdRequest.typeName = "spwn.account.v1.InternalAccountServiceGetFanByFirestoreIdRequest";
InternalAccountServiceGetFanByFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetFanByFirestoreIdResponse
 */
class InternalAccountServiceGetFanByFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetFanByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetFanByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetFanByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetFanByFirestoreIdResponse, a, b);
    }
}
exports.InternalAccountServiceGetFanByFirestoreIdResponse = InternalAccountServiceGetFanByFirestoreIdResponse;
InternalAccountServiceGetFanByFirestoreIdResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetFanByFirestoreIdResponse.typeName = "spwn.account.v1.InternalAccountServiceGetFanByFirestoreIdResponse";
InternalAccountServiceGetFanByFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fan", kind: "message", T: internal_common_pb_1.InternalFan },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetBrandByFirestoreIdRequest
 */
class InternalAccountServiceGetBrandByFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetBrandByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetBrandByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetBrandByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetBrandByFirestoreIdRequest, a, b);
    }
}
exports.InternalAccountServiceGetBrandByFirestoreIdRequest = InternalAccountServiceGetBrandByFirestoreIdRequest;
InternalAccountServiceGetBrandByFirestoreIdRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetBrandByFirestoreIdRequest.typeName = "spwn.account.v1.InternalAccountServiceGetBrandByFirestoreIdRequest";
InternalAccountServiceGetBrandByFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetBrandByFirestoreIdResponse
 */
class InternalAccountServiceGetBrandByFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetBrandByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetBrandByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetBrandByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetBrandByFirestoreIdResponse, a, b);
    }
}
exports.InternalAccountServiceGetBrandByFirestoreIdResponse = InternalAccountServiceGetBrandByFirestoreIdResponse;
InternalAccountServiceGetBrandByFirestoreIdResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetBrandByFirestoreIdResponse.typeName = "spwn.account.v1.InternalAccountServiceGetBrandByFirestoreIdResponse";
InternalAccountServiceGetBrandByFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: internal_common_pb_1.InternalBrand },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetBrandByIdRequest
 */
class InternalAccountServiceGetBrandByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetBrandByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetBrandByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetBrandByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetBrandByIdRequest, a, b);
    }
}
exports.InternalAccountServiceGetBrandByIdRequest = InternalAccountServiceGetBrandByIdRequest;
InternalAccountServiceGetBrandByIdRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetBrandByIdRequest.typeName = "spwn.account.v1.InternalAccountServiceGetBrandByIdRequest";
InternalAccountServiceGetBrandByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetBrandByIdResponse
 */
class InternalAccountServiceGetBrandByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetBrandByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetBrandByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetBrandByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetBrandByIdResponse, a, b);
    }
}
exports.InternalAccountServiceGetBrandByIdResponse = InternalAccountServiceGetBrandByIdResponse;
InternalAccountServiceGetBrandByIdResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetBrandByIdResponse.typeName = "spwn.account.v1.InternalAccountServiceGetBrandByIdResponse";
InternalAccountServiceGetBrandByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: internal_common_pb_1.InternalBrand },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetBrandsRequest
 */
class InternalAccountServiceGetBrandsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetBrandsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetBrandsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetBrandsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetBrandsRequest, a, b);
    }
}
exports.InternalAccountServiceGetBrandsRequest = InternalAccountServiceGetBrandsRequest;
InternalAccountServiceGetBrandsRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetBrandsRequest.typeName = "spwn.account.v1.InternalAccountServiceGetBrandsRequest";
InternalAccountServiceGetBrandsRequest.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetBrandsResponse
 */
class InternalAccountServiceGetBrandsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.InternalBrand brands = 1;
         */
        this.brands = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetBrandsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetBrandsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetBrandsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetBrandsResponse, a, b);
    }
}
exports.InternalAccountServiceGetBrandsResponse = InternalAccountServiceGetBrandsResponse;
InternalAccountServiceGetBrandsResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetBrandsResponse.typeName = "spwn.account.v1.InternalAccountServiceGetBrandsResponse";
InternalAccountServiceGetBrandsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brands", kind: "message", T: internal_common_pb_1.InternalBrand, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetBrandByIdsRequest
 */
class InternalAccountServiceGetBrandByIdsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 指定されたbrand_idでbrandを取得する
         *
         * @generated from field: repeated string brand_ids = 1;
         */
        this.brandIds = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetBrandByIdsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetBrandByIdsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetBrandByIdsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetBrandByIdsRequest, a, b);
    }
}
exports.InternalAccountServiceGetBrandByIdsRequest = InternalAccountServiceGetBrandByIdsRequest;
InternalAccountServiceGetBrandByIdsRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetBrandByIdsRequest.typeName = "spwn.account.v1.InternalAccountServiceGetBrandByIdsRequest";
InternalAccountServiceGetBrandByIdsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetBrandByIdsResponse
 */
class InternalAccountServiceGetBrandByIdsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * request指定された中で存在するbrandを配列で返す
         *
         * @generated from field: repeated spwn.account.v1.InternalBrand brands = 1;
         */
        this.brands = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetBrandByIdsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetBrandByIdsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetBrandByIdsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetBrandByIdsResponse, a, b);
    }
}
exports.InternalAccountServiceGetBrandByIdsResponse = InternalAccountServiceGetBrandByIdsResponse;
InternalAccountServiceGetBrandByIdsResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetBrandByIdsResponse.typeName = "spwn.account.v1.InternalAccountServiceGetBrandByIdsResponse";
InternalAccountServiceGetBrandByIdsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brands", kind: "message", T: internal_common_pb_1.InternalBrand, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceAddBrandToTenantRequest
 */
class InternalAccountServiceAddBrandToTenantRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 3;
         */
        this.slug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceAddBrandToTenantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceAddBrandToTenantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceAddBrandToTenantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceAddBrandToTenantRequest, a, b);
    }
}
exports.InternalAccountServiceAddBrandToTenantRequest = InternalAccountServiceAddBrandToTenantRequest;
InternalAccountServiceAddBrandToTenantRequest.runtime = protobuf_1.proto3;
InternalAccountServiceAddBrandToTenantRequest.typeName = "spwn.account.v1.InternalAccountServiceAddBrandToTenantRequest";
InternalAccountServiceAddBrandToTenantRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceAddBrandToTenantResponse
 */
class InternalAccountServiceAddBrandToTenantResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceAddBrandToTenantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceAddBrandToTenantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceAddBrandToTenantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceAddBrandToTenantResponse, a, b);
    }
}
exports.InternalAccountServiceAddBrandToTenantResponse = InternalAccountServiceAddBrandToTenantResponse;
InternalAccountServiceAddBrandToTenantResponse.runtime = protobuf_1.proto3;
InternalAccountServiceAddBrandToTenantResponse.typeName = "spwn.account.v1.InternalAccountServiceAddBrandToTenantResponse";
InternalAccountServiceAddBrandToTenantResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetTenantByFirestoreIdRequest
 */
class InternalAccountServiceGetTenantByFirestoreIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_firestore_id = 1;
         */
        this.tenantFirestoreId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetTenantByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetTenantByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetTenantByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetTenantByFirestoreIdRequest, a, b);
    }
}
exports.InternalAccountServiceGetTenantByFirestoreIdRequest = InternalAccountServiceGetTenantByFirestoreIdRequest;
InternalAccountServiceGetTenantByFirestoreIdRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetTenantByFirestoreIdRequest.typeName = "spwn.account.v1.InternalAccountServiceGetTenantByFirestoreIdRequest";
InternalAccountServiceGetTenantByFirestoreIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetTenantByFirestoreIdResponse
 */
class InternalAccountServiceGetTenantByFirestoreIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetTenantByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetTenantByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetTenantByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetTenantByFirestoreIdResponse, a, b);
    }
}
exports.InternalAccountServiceGetTenantByFirestoreIdResponse = InternalAccountServiceGetTenantByFirestoreIdResponse;
InternalAccountServiceGetTenantByFirestoreIdResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetTenantByFirestoreIdResponse.typeName = "spwn.account.v1.InternalAccountServiceGetTenantByFirestoreIdResponse";
InternalAccountServiceGetTenantByFirestoreIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant", kind: "message", T: internal_common_pb_1.InternalTenant },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetTenantByIdRequest
 */
class InternalAccountServiceGetTenantByIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetTenantByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetTenantByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetTenantByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetTenantByIdRequest, a, b);
    }
}
exports.InternalAccountServiceGetTenantByIdRequest = InternalAccountServiceGetTenantByIdRequest;
InternalAccountServiceGetTenantByIdRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetTenantByIdRequest.typeName = "spwn.account.v1.InternalAccountServiceGetTenantByIdRequest";
InternalAccountServiceGetTenantByIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetTenantByIdResponse
 */
class InternalAccountServiceGetTenantByIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetTenantByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetTenantByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetTenantByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetTenantByIdResponse, a, b);
    }
}
exports.InternalAccountServiceGetTenantByIdResponse = InternalAccountServiceGetTenantByIdResponse;
InternalAccountServiceGetTenantByIdResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetTenantByIdResponse.typeName = "spwn.account.v1.InternalAccountServiceGetTenantByIdResponse";
InternalAccountServiceGetTenantByIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant", kind: "message", T: internal_common_pb_1.InternalTenant },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest
 */
class InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest, a, b);
    }
}
exports.InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest = InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest;
InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest.typeName = "spwn.account.v1.InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest";
InternalAccountServiceGetCoreFanByBrandIdAndUserIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse
 */
class InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse, a, b);
    }
}
exports.InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse = InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse;
InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse.typeName = "spwn.account.v1.InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse";
InternalAccountServiceGetCoreFanByBrandIdAndUserIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "core_fan", kind: "message", T: internal_common_pb_1.InternalAccountCoreFan },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetTenantOwnerByBrandIdRequest
 */
class InternalAccountServiceGetTenantOwnerByBrandIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetTenantOwnerByBrandIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetTenantOwnerByBrandIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetTenantOwnerByBrandIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetTenantOwnerByBrandIdRequest, a, b);
    }
}
exports.InternalAccountServiceGetTenantOwnerByBrandIdRequest = InternalAccountServiceGetTenantOwnerByBrandIdRequest;
InternalAccountServiceGetTenantOwnerByBrandIdRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetTenantOwnerByBrandIdRequest.typeName = "spwn.account.v1.InternalAccountServiceGetTenantOwnerByBrandIdRequest";
InternalAccountServiceGetTenantOwnerByBrandIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetTenantOwnerByBrandIdResponse
 */
class InternalAccountServiceGetTenantOwnerByBrandIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetTenantOwnerByBrandIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetTenantOwnerByBrandIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetTenantOwnerByBrandIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetTenantOwnerByBrandIdResponse, a, b);
    }
}
exports.InternalAccountServiceGetTenantOwnerByBrandIdResponse = InternalAccountServiceGetTenantOwnerByBrandIdResponse;
InternalAccountServiceGetTenantOwnerByBrandIdResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetTenantOwnerByBrandIdResponse.typeName = "spwn.account.v1.InternalAccountServiceGetTenantOwnerByBrandIdResponse";
InternalAccountServiceGetTenantOwnerByBrandIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "owner", kind: "message", T: internal_common_pb_1.InternalCreatorCore },
    { no: 2, name: "brand", kind: "message", T: internal_common_pb_1.InternalBrandCore },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetCoreFansByBrandIdRequest
 */
class InternalAccountServiceGetCoreFansByBrandIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetCoreFansByBrandIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetCoreFansByBrandIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetCoreFansByBrandIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetCoreFansByBrandIdRequest, a, b);
    }
}
exports.InternalAccountServiceGetCoreFansByBrandIdRequest = InternalAccountServiceGetCoreFansByBrandIdRequest;
InternalAccountServiceGetCoreFansByBrandIdRequest.runtime = protobuf_1.proto3;
InternalAccountServiceGetCoreFansByBrandIdRequest.typeName = "spwn.account.v1.InternalAccountServiceGetCoreFansByBrandIdRequest";
InternalAccountServiceGetCoreFansByBrandIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountServiceGetCoreFansByBrandIdResponse
 */
class InternalAccountServiceGetCoreFansByBrandIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.InternalFan fans = 1;
         */
        this.fans = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountServiceGetCoreFansByBrandIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountServiceGetCoreFansByBrandIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountServiceGetCoreFansByBrandIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountServiceGetCoreFansByBrandIdResponse, a, b);
    }
}
exports.InternalAccountServiceGetCoreFansByBrandIdResponse = InternalAccountServiceGetCoreFansByBrandIdResponse;
InternalAccountServiceGetCoreFansByBrandIdResponse.runtime = protobuf_1.proto3;
InternalAccountServiceGetCoreFansByBrandIdResponse.typeName = "spwn.account.v1.InternalAccountServiceGetCoreFansByBrandIdResponse";
InternalAccountServiceGetCoreFansByBrandIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "fans", kind: "message", T: internal_common_pb_1.InternalFan, repeated: true },
]);
//# sourceMappingURL=internal_service_pb.js.map